// client/src/components/TopUpModal.jsx
// ПОЛНОСТЬЮ ЗАМЕНИ этот файл на то, что ниже
import React, { useEffect, useState, useRef, useMemo } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// [LOG]
const DEBUG_HTTP = true;
function maskToken(t = '') {
  if (!t) return t;
  const clean = String(t);
  if (clean.length <= 16) return clean;
  return `${clean.slice(0, 10)}…${clean.slice(-6)}`;
}

const styles = {
  card: {
    padding: 24,
    background: '#181c27', // как профильная карточка
    color: '#e5e7eb',
    borderRadius: 16,
    maxWidth: 760,
    width: '100%',
    boxShadow: '0 18px 45px rgba(0,0,0,0.65)',
    border: '1px solid rgba(255,255,255,0.05)',
    fontFamily:
      "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  h3: {
    fontSize: 20,
    margin: '0 0 6px',
    fontWeight: 600,
  },
  sub: {
    fontSize: 13,
    color: '#9ca3af',
  },
  step: {
    fontSize: 11,
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  input: {
    width: '100%',
    height: 44,
    fontSize: 15,
    color: '#e5e7eb',
    background: '#020617',
    border: '1px solid #374151',
    borderRadius: 10,
    padding: '0 12px',
    outline: 'none',
  },
  btnPrimary: {
    width: '100%',
    height: 44,
    borderRadius: 999,
    border: 'none',
    backgroundImage: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
    color: '#111827',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(251,191,36,0.35)',
  },
  btnPrimaryDisabled: {
    opacity: 0.6,
    cursor: 'default',
  },
  btnGhost: {
    height: 36,
    padding: '0 14px',
    borderRadius: 999,
    border: '1px solid #334155',
    background: 'rgba(15,23,42,0.8)',
    color: '#e5e7eb',
    fontSize: 13,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    whiteSpace: 'nowrap',
  },
  copyRow: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  mono: {
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },
  codeBox: {
    fontSize: 16,
    background: '#020617',
    color: '#e5e7eb',
    padding: '8px 10px',
    borderRadius: 10,
    border: '1px solid #374151',
    wordBreak: 'break-all',
    flex: 1,
  },
  codeBoxSmall: {
    fontSize: 13,
    background: '#020617',
    color: '#e5e7eb',
    padding: '8px 10px',
    borderRadius: 10,
    border: '1px solid #374151',
    wordBreak: 'break-all',
    flex: 1,
  },
  section: {
    background: '#0b1220',
    border: '1px solid #1f2937',
    borderRadius: 12,
    padding: 12,
    marginTop: 12,
  },
  label: { fontSize: 13, color: '#94a3b8', marginBottom: 6 },
  badge: (bg) => ({
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    background: bg,
    color: '#0f172a',
    textTransform: 'uppercase',
  }),
  tabs: {
    display: 'flex',
    gap: 8,
    marginTop: 16,
    marginBottom: 4,
  },
  tabBtn: (active) => ({
    flex: 1,
    height: 40,
    borderRadius: 999,
    border: '1px solid ' + (active ? '#fbbf24' : '#374151'),
    background: active ? 'rgba(251,191,36,0.08)' : 'transparent',
    color: active ? '#fde68a' : '#e5e7eb',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
  }),
  helpList: { marginTop: 10, display: 'grid', gap: 10 },
  helpItem: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr',
    gap: 10,
    alignItems: 'start',
  },
  helpIcon: { width: 24, height: 24 },

  // ✅ НОВОЕ: контейнер со скроллом только для "Инструкция для новичка"
  helpScroll: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 8, // чтобы текст не прилипал к скроллбару
    borderRadius: 12,
  },
};

function HelpIcon({ type }) {
  const common = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  return (
    <div style={{ ...styles.helpIcon, color: '#93c5fd' }}>
      {type === 'wallet' && (
        <svg viewBox="0 0 24 24">
          <path {...common} d="M3 7h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3V7z" />
          <path {...common} d="M16 12h4" />
          <path {...common} d="M3 7V5a2 2 0 0 1 2-2h12" />
        </svg>
      )}
      {type === 'usdt' && (
        <svg viewBox="0 0 24 24">
          <circle {...common} cx="12" cy="12" r="10" />
          <path {...common} d="M7 8h10M9 12h6M12 6v12" />
        </svg>
      )}
      {type === 'network' && (
        <svg viewBox="0 0 24 24">
          <path {...common} d="M3 12h18M12 3v18" />
          <circle {...common} cx="12" cy="12" r="8" />
        </svg>
      )}
      {type === 'hash' && (
        <svg viewBox="0 0 24 24">
          <path {...common} d="M5 9h14M5 15h14M9 5v14M15 5v14" />
        </svg>
      )}
      {type === 'done' && (
        <svg viewBox="0 0 24 24">
          <path {...common} d="M20 6L9 17l-5-5" />
        </svg>
      )}
    </div>
  );
}

const TopUpModal = () => {
  const { t: translate } = useTranslation();
  // логика осталась той же
  const [amountUsd, setAmountUsd] = useState(10);
  const [error, setError] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const [txHash, setTxHash] = useState('');
  const [confirmMsg, setConfirmMsg] = useState('');
  const [copied, setCopied] = useState('');

  const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const [invoice, setInvoice] = useState(null);
  const [status, setStatus] = useState(null); // pending | paid | confirmed
  const pollRef = useRef(null);
  const [activeTab, setActiveTab] = useState('pay'); // pay | help

  const http = useMemo(() => axios.create(), []);

  // ✅ НОВОЕ: вычисляем высоту для скролла в "Инструкция для новичка"
  const cardRef = useRef(null);
  const [helpMaxH, setHelpMaxH] = useState(320);

  // перехватчики запросов/ответов
  useEffect(() => {
    const reqId = http.interceptors.request.use(
      (config) => {
        try {
          const token = localStorage.getItem('token');
          if (token) {
            config.headers = config.headers || {};
            config.headers['Authorization'] = `Bearer ${token}`;
          }
          if (DEBUG_HTTP) {
            console.log(
              '%c[HTTP →] request',
              'color: #0b74de; font-weight: bold;',
              {
                method: config.method,
                url: config.baseURL
                  ? `${config.baseURL}${config.url}`
                  : config.url,
                headers: config.headers,
                data: config.data,
                withCredentials: config.withCredentials,
              }
            );
          }
        } catch {}
        return config;
      },
      (error) => {
        if (DEBUG_HTTP)
          console.log(
            '%c[HTTP →] request ERROR',
            'color: #d14343; font-weight: bold;',
            error
          );
        return Promise.reject(error);
      }
    );

    const resId = http.interceptors.response.use(
      (response) => {
        try {
          if (DEBUG_HTTP) {
            console.log(
              '%c[HTTP ←] response',
              'color: #1a7f37; font-weight: bold;',
              {
                url: response?.config?.url,
                status: response?.status,
                data: response?.data,
                headers: response?.headers,
              }
            );
          }
        } catch {}
        return response;
      },
      (error) => {
        try {
          if (DEBUG_HTTP) {
            if (error?.response) {
              console.log(
                '%c[HTTP ←] response ERROR',
                'color: #d14343; font-weight: bold;',
                {
                  url: error?.response?.config?.url,
                  status: error?.response?.status,
                  data: error?.response?.data,
                  headers: error?.response?.headers,
                }
              );
            } else {
              console.log(
                '%c[HTTP ←] network ERROR',
                'color: #d14343; font-weight: bold;',
                error?.message || error
              );
            }
          }
        } catch {}
        return Promise.reject(error);
      }
    );

    return () => {
      http.interceptors.request.eject(reqId);
      http.interceptors.response.eject(resId);
    };
  }, [http]);

  useEffect(() => {
    if (!DEBUG_HTTP) return;
    const token = localStorage.getItem('token');
    console.log('[TopUpModal] mounted', {
      API_ORIGIN,
      hasTokenInLocalStorage: Boolean(token),
      tokenMasked: maskToken(token),
      localStorageKeys: Object.keys(localStorage || {}),
    });
  }, [API_ORIGIN]);

  // ✅ НОВОЕ: считаем доступную высоту под "Инструкция для новичка"
  useEffect(() => {
    const calc = () => {
      const el = cardRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();

      // сколько места осталось до низа экрана
      const spaceToBottom = window.innerHeight - rect.top - 24; // 24 — запас снизу

      // сколько сверху занимает: заголовок + подзаголовок + табы + отступы
      // это константа "примерно", можно подрегулировать (150–220)
      const reservedTop = 190;

      const max = Math.max(220, Math.floor(spaceToBottom - reservedTop));
      setHelpMaxH(max);
    };

    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, []);

  const startPayment = async () => {
    try {
      setError('');
      setIsCreating(true);
      setInvoice(null);
      setStatus(null);
      setTxHash('');
      setConfirmMsg('');
      setActiveTab('pay');

      if (DEBUG_HTTP) {
        const token = localStorage.getItem('token');
        console.log('[TopUpModal] startPayment →', {
          url: `${API_ORIGIN}/api/payments/crypto/invoice`,
          amountUsd: Number(amountUsd),
          tokenMasked: maskToken(token),
          API_ORIGIN,
        });
      }

      const { data } = await http.post(
        `${API_ORIGIN}/api/payments/crypto/invoice`,
        { amountUsd: Number(amountUsd) }
      );

      setInvoice(data);
      setStatus('pending');
    } catch (e) {
      console.error(e);
      setError(e?.response?.data?.message || translate('profile.cryptoTopUp.createInvoiceError'));
    } finally {
      setIsCreating(false);
    }
  };

  const confirmManually = async () => {
    if (!invoice?.invoiceId || !txHash) return;
    try {
      setConfirmMsg('');
      const payload = { invoiceId: invoice.invoiceId, txHash };

      if (DEBUG_HTTP) {
        const token = localStorage.getItem('token');
        console.log('[TopUpModal] confirmManually →', {
          url: `${API_ORIGIN}/api/payments/crypto/confirm`,
          payload,
          tokenMasked: maskToken(token),
          API_ORIGIN,
        });
      }

      await http.post(
        `${API_ORIGIN}/api/payments/crypto/confirm`,
        payload
      );

      setStatus('confirmed');
      setConfirmMsg(
        translate('profile.cryptoTopUp.confirmedMessage')
      );
    } catch (e) {
      const msg = e?.response?.data?.message;
      if (e?.response?.status === 409) {
        setConfirmMsg(msg || translate('profile.cryptoTopUp.hashUsed'));
      } else {
        setConfirmMsg(msg || translate('profile.cryptoTopUp.confirmError'));
      }
    }
  };

  // поллинг статуса
  useEffect(() => {
    if (!invoice?.invoiceId) return;
    if (pollRef.current) clearInterval(pollRef.current);

    const tick = async () => {
      try {
        const { data } = await http.get(
          `${API_ORIGIN}/api/payments/crypto/status`,
          { params: { invoiceId: invoice.invoiceId } }
        );
        setStatus(data.status);
        if (data.status === 'confirmed') {
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
      } catch (e) {
        console.warn('[status poll]', e?.response?.data || e.message);
      }
    };

    tick();
    pollRef.current = setInterval(tick, 3000);
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [invoice?.invoiceId, API_ORIGIN, http]);

  // обновляем баланс в шапке
  useEffect(() => {
    if (status === 'confirmed') {
      window.dispatchEvent(new CustomEvent('balance-updated'));
    }
  }, [status]);

  const copy = async (text, what = translate('profile.common.copied')) => {
    try {
      await navigator.clipboard.writeText(String(text));
    } catch {
      const t = document.createElement('textarea');
      t.value = String(text);
      document.body.appendChild(t);
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);
    }
    setCopied(what);
    setTimeout(() => setCopied(''), 1200);
  };

  const StatusBadge = () => {
    if (status === 'confirmed')
      return <span style={styles.badge('#34d399')}>confirmed</span>;
    if (status === 'paid')
      return <span style={styles.badge('#fbbf24')}>paid</span>;
    if (status === 'pending')
      return <span style={styles.badge('#e5e7eb')}>pending</span>;
    return <span style={styles.badge('#e5e7eb')}>—</span>;
  };

  const amountToShow =
    typeof invoice?.amountToken === 'number'
      ? invoice.amountToken.toFixed(2)
      : Number(invoice?.amountToken || 0).toFixed(2);

  const isPrimaryDisabled = isCreating || amountUsd <= 0;

  return (
    <div ref={cardRef} style={styles.card}>
      <h3 style={styles.h3}>{translate('profile.cryptoTopUp.title')}</h3>
      <div style={styles.sub}>
        {translate('profile.cryptoTopUp.subtitle')}
      </div>

      {/* Вкладки */}
      <div style={styles.tabs}>
        <button
          style={styles.tabBtn(activeTab === 'pay')}
          onClick={() => setActiveTab('pay')}
        >
          {translate('profile.cryptoTopUp.payTab')}
        </button>
        <button
          style={styles.tabBtn(activeTab === 'help')}
          onClick={() => setActiveTab('help')}
        >
          {translate('profile.cryptoTopUp.helpTab')}
        </button>
      </div>

      {activeTab === 'pay' && (
        <>
          {!invoice && (
            <div style={{ marginTop: 12 }}>
              <div style={{ ...styles.step, marginBottom: 6 }}>
                {translate('profile.cryptoTopUp.step1')}
              </div>
              <input
                type="number"
                min={1}
                value={amountUsd}
                onChange={(e) =>
                  setAmountUsd(Number(e.target.value || 0))
                }
                style={styles.input}
              />
              <div style={{ height: 10 }} />
              <button
                onClick={startPayment}
                disabled={isPrimaryDisabled}
                style={{
                  ...styles.btnPrimary,
                  ...(isPrimaryDisabled ? styles.btnPrimaryDisabled : {}),
                }}
              >
                {isCreating ? translate('profile.cryptoTopUp.preparing') : translate('profile.cryptoTopUp.createInvoice')}
              </button>
              {error && (
                <p style={{ color: '#fecaca', marginTop: 8, fontSize: 13 }}>
                  {error}
                </p>
              )}
              <p style={{ ...styles.sub, marginTop: 8 }}>
                {translate('profile.cryptoTopUp.afterInvoice')}
              </p>
            </div>
          )}

          {invoice && (
            <div style={{ marginTop: 12 }}>
              {/* Сумма */}
              <div style={styles.section}>
                <div style={styles.label}>
                  {translate('profile.cryptoTopUp.step2')}
                </div>
                <div style={styles.copyRow}>
                  <code style={{ ...styles.codeBox, ...styles.mono }}>
                    {amountToShow}
                  </code>
                  <button
                    style={styles.btnGhost}
                    onClick={() =>
                      copy(amountToShow, translate('profile.cryptoTopUp.amountCopied'))
                    }
                  >
                    {translate('profile.common.copy')}
                  </button>
                </div>
                <div style={{ ...styles.sub, marginTop: 6 }}>
                  {translate('profile.cryptoTopUp.chooseNetwork')}
                </div>
              </div>

              {/* Адрес */}
              <div style={styles.section}>
                <div style={styles.label}>
                  {translate('profile.cryptoTopUp.recipientAddress')}
                </div>
                <div style={styles.copyRow}>
                  <code
                    style={{ ...styles.codeBoxSmall, ...styles.mono }}
                  >
                    {invoice.payToAddress}
                  </code>
                  <button
                    style={styles.btnGhost}
                    onClick={() =>
                      copy(invoice.payToAddress, translate('profile.cryptoTopUp.addressCopied'))
                    }
                  >
                    {translate('profile.common.copy')}
                  </button>
                </div>
                <div style={{ marginTop: 8 }}>
                  <a
                    href={invoice.explorerAddress}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#93c5fd', fontSize: 13 }}
                  >
                    {translate('profile.cryptoTopUp.openBscScan')}
                  </a>
                </div>
              </div>

              {/* Подтверждение */}
              <div style={styles.section}>
                <div style={styles.label}>
                  {translate('profile.cryptoTopUp.step3')}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    type="text"
                    placeholder={translate('profile.cryptoTopUp.hashPlaceholder')}
                    value={txHash}
                    onChange={(e) => setTxHash(e.target.value)}
                    style={{ ...styles.input, height: 40, fontSize: 14 }}
                  />
                  <button
                    onClick={confirmManually}
                    disabled={!txHash}
                    style={{
                      ...styles.btnGhost,
                      fontWeight: 600,
                      opacity: txHash ? 1 : 0.6,
                      cursor: txHash ? 'pointer' : 'default',
                    }}
                  >
                    {translate('profile.cryptoTopUp.confirm')}
                  </button>
                </div>
                {confirmMsg && (
                  <div style={{ marginTop: 6, fontSize: 13 }}>
                    {confirmMsg}
                  </div>
                )}
              </div>

              {/* Статус */}
              <div style={{ marginTop: 12 }}>
                <StatusBadge />
                <div style={{ ...styles.sub, marginTop: 6 }}>
                  {translate('profile.cryptoTopUp.statusHint')}
                </div>
              </div>

              {/* маленький тост копирования */}
              {copied && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    background: '#111827',
                    border: '1px solid #374151',
                    color: '#e5e7eb',
                    padding: '8px 12px',
                    borderRadius: 8,
                    fontSize: 13,
                  }}
                >
                  {copied}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {activeTab === 'help' && (
        <div
          style={{
            ...styles.section,
            background: 'transparent',
            border: 'none',
            padding: 0,
            marginTop: 16,
          }}
        >
          <div
            style={{
              fontWeight: 700,
              marginBottom: 8,
              fontSize: 16,
            }}
          >
            {translate('profile.cryptoTopUp.helpTitle')}
          </div>

          {/* ✅ НОВОЕ: скроллим только этот блок */}
          <div style={{ ...styles.helpScroll, maxHeight: helpMaxH }}>
            <div style={styles.helpList}>
              <div style={styles.helpItem}>
                <HelpIcon type="wallet" />
                <div>
                  <b>{translate('profile.cryptoTopUp.help.walletTitle')}</b>
                  <br />
                  {translate('profile.cryptoTopUp.help.walletText')}
                </div>
              </div>
              <div style={styles.helpItem}>
                <HelpIcon type="usdt" />
                <div>
                  <b>{translate('profile.cryptoTopUp.help.buyTitle')}</b>{' '}
                  {translate('profile.cryptoTopUp.help.buyText')}
                </div>
              </div>
              <div style={styles.helpItem}>
                <HelpIcon type="network" />
                <div>
                  <b>{translate('profile.cryptoTopUp.help.networkTitle')}</b>{' '}
                  {translate('profile.cryptoTopUp.help.networkText')}
                </div>
              </div>
              <div style={styles.helpItem}>
                <HelpIcon type="hash" />
                <div>
                  <b>{translate('profile.cryptoTopUp.help.sentTitle')}</b>{' '}
                  {translate('profile.cryptoTopUp.help.sentText')}
                </div>
              </div>
              <div style={styles.helpItem}>
                <HelpIcon type="done" />
                <div>
                  <b>{translate('profile.cryptoTopUp.help.doneTitle')}</b>{' '}
                  {translate('profile.cryptoTopUp.help.doneText')}
                </div>
              </div>
            </div>

            <div style={{ ...styles.sub, marginTop: 12 }}>
              {translate('profile.cryptoTopUp.help.support')}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopUpModal;